export const ROLES = {
  AGENCY_OWNER: "agency_owner",
  AGENCY_STAFF: "agency_staff",
  SALES_ACCOUNT_SPECIALIST: "sales_account_specialist",
  HELPDESK: "helpdesk",
  TECHNICAL_SUPPORT_SPECIALIST: "technical_support_specialist",
  SUPER_ADMIN: "super_admin",
};

// Internal staff roles that can view the agency list / audit log / notifications.
export const INTERNAL_ROLES = [
  ROLES.SUPER_ADMIN,
  ROLES.SALES_ACCOUNT_SPECIALIST,
  ROLES.HELPDESK,
  ROLES.TECHNICAL_SUPPORT_SPECIALIST,
];

export const ROLE_LABELS = {
  [ROLES.AGENCY_OWNER]: "Agency Owner",
  [ROLES.AGENCY_STAFF]: "Agency Staff",
  [ROLES.SALES_ACCOUNT_SPECIALIST]: "Sales/Account Specialist",
  [ROLES.HELPDESK]: "Helpdesk",
  [ROLES.TECHNICAL_SUPPORT_SPECIALIST]: "Technical Support Specialist",
  [ROLES.SUPER_ADMIN]: "Super Admin",
};
